import { formatCookie } from '../cookieAttributes';

export const setCookie = ({ cookieName, cookieValue }) => {
  document.cookie = formatCookie(cookieName, cookieValue);
};
